import React from 'react';
import { ModuleBase, Stack, Text, Link, Box } from '@/components';
import { SideBySideModuleModel } from './SideBySideModule';
import classNames from 'classnames';
import { fadeInLeft, fadeInRight } from '@/animations';

const MembershipInstantAccess = (data: SideBySideModuleModel) => {
  const {
    props: { alignment, title, link1, cards },
  } = data;

  return (
    <ModuleBase data={data} noPadding className="MembershipInstantAccess overflow-hidden py-10 lg:py-18">
      <Stack
        className={classNames(
          'container flex flex-col justify-between gap-10 lg:items-stretch lg:gap-8',
          alignment === 'Right' ? 'lg:flex-row-reverse' : 'lg:flex-row',
        )}
      >
        <div className="color-from-bg flex w-full flex-grow flex-col justify-between lg:w-1/2">
          {title && <Text className="text-style-h2" dangerouslySetInnerHTML={{ __html: title }} />}
          {link1 && <Link animate className="btn primary v2 mt-10" link={link1} />}
        </div>
        <div className="color-from-bg relative flex lg:w-1/2">
          {cards && (
            <div className="flex w-full flex-col">
              {cards.map((card, index) => (
                <Box
                  key={index}
                  animation={alignment === 'Right' ? fadeInRight : fadeInLeft}
                  className={classNames(
                    index !== 0 && 'lg:after-extended-line-top border-t lg:border-t-0',
                    'border-from-bg flex flex-col gap-1 py-5 first:pt-0',
                  )}
                >
                  <p className="text-style-h4">{card.title}</p>
                </Box>
              ))}
            </div>
          )}
        </div>
      </Stack>
    </ModuleBase>
  );
};

export default MembershipInstantAccess;
